import styled from 'styled-components';

import { Skeleton } from '@sorare/core/src/atoms/animations/Skeleton';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';

const Relative = styled(Vertical)`
  position: relative;
  isolation: isolate;
  align-self: center;
`;
const Matchups = styled(Skeleton)`
  width: 100px;
  height: var(--triple-unit);
  border-radius: var(--half-unit);
`;

export const MatchupsSkeleton = () => {
  return (
    <Relative center>
      <Matchups />
    </Relative>
  );
};
